const requestEvaluationApi = async (path, options = {}) => {
  const response = await fetch(`${process.env.REACT_APP_API_ADDRESS}${path}`, {
    ...options,
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`,
      ...(options.body ? { 'Content-Type': options.method === 'PATCH' ? 'application/merge-patch+json' : 'application/json' } : {}),
      ...options.headers,
    },
  });

  const data = await response.json().catch(() => null);
  if (!response.ok) {
    const error = new Error(data?.error ?? `API request failed (${response.status}).`);
    error.status = response.status;
    throw error;
  }

  return data;
};

export const getEvaluationDatasets = async () => {
  const data = await requestEvaluationApi('datasets');
  return Array.isArray(data) ? data : data?.['hydra:member'] ?? [];
};

export const getEvaluationDataset = (id) => requestEvaluationApi(`datasets/${id}`);

export const getEvaluationAvailability = (clientId, defectType) => {
  const params = new URLSearchParams({ client_id: clientId, defect_type: String(defectType) });
  return requestEvaluationApi(`evaluations/availability?${params}`);
};

export const createEvaluationDataset = (data) => requestEvaluationApi('evaluations', { method: 'POST', body: JSON.stringify(data) });
export const saveEvaluationImage = (imageId, state) => requestEvaluationApi(`evaluations/images/${imageId}`, { method: 'PATCH', body: JSON.stringify({ state }) });

export const getEvaluationDatasetMetadata = (dataset) => {
  return dataset?.dataset_images?.find((image) => image.annotation_data?.evaluation?.type === 'defect_evaluation')?.annotation_data?.evaluation ?? null;
};

export const isEvaluationDataset = (dataset, clientId) => getEvaluationDatasetMetadata(dataset)?.client_id === clientId;

export const getEvaluationPrecision = (images) => {
  const correct = images.filter((image) => image.state === 'validated').length;
  const incorrect = images.filter((image) => image.state === 'error').length;
  return { correct, incorrect, evaluated: correct + incorrect, precision: correct + incorrect > 0 ? correct / (correct + incorrect) * 100 : null };
};
